<template lang="pug">
div.vr-image-wrapper.w-flex.justify-center.align-center(
  :style="{width,height}"
)
  w-spinner(v-if="showLoadingIcon")
  div.vr-image(
    ref="vrimage"
  )
</template>

<script>
import { mapGetters } from 'vuex'
import {PanoViewer} from "@egjs/view360"

export default {
  name: 'Image360',
  data() {
    return {
      viewer: undefined,
      showLoadingIcon: true,
    }
  },
  props: {
    src: {
      type: String,
      required: true,
      note: 'Path to 360 Image'
    },
    width: {
      type: String,
      required: false,
      default: '100%',
      note: 'CSS width'
    },
    height: {
      type: String,
      required: false,
      default: '100%',
      note: 'CSS height'
    },
    yaw: {
      type: Number,
      required: false,
      default: 30
    },
    pitch: {
      type: Number,
      required: false,
      default: 0
    },
    fov: {
      type: Number,
      required: false,
      default: 85
    }
  },
  computed: {
    ...mapGetters('global',{
      portrait: 'portrait',
      viewport: 'viewport'
    }),
  },
  mounted() {
    const {yaw, pitch, fov} = this
    this.viewer = new PanoViewer(
      this.$refs.vrimage,
      { image: this.src, yaw, pitch, fov }
    );
    this.viewer.on("ready", () => {
        this.showLoadingIcon = false
    });
    window.addEventListener("resize", this.updateViewportDimensions);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateViewportDimensions)
    this.viewer.destroy()
  },
  methods: {
    updateViewportDimensions() {
      this.viewer.updateViewportDimensions()
    }
  },
  components: {
  }
}
</script>

<style lang="scss">
.vr-image-wrapper {
  .vr-image {
    cursor: grab;
    position: relative;
    width: 100%;
    height: 100%;
  }
  .w-spinner {
    position: absolute;
  }
}
</style>
